import { BaseModel } from '../abstractions/base.model';
import { ErrorMessageTypeEnum } from './enums/error-message-type.enum';

export class ErrorMessageModel extends BaseModel {
    message: string;
    type = ErrorMessageTypeEnum.Error;

    constructor(init: ErrorMessageModel) {
        super();
        Object.assign(this, init);
    }
}
